import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export const FORCED_RESET_FALLBACK_MESSAGE = 'We could not change your password. Please try again.';

@Injectable({ providedIn: 'root' })
export class ForcedPasswordResetService {
  constructor(private http: HttpClient) {}

  /** Sets the first password and returns the signed token Auth0 needs to resume the login. */
  resetPassword(sessionToken: string, state: string, newPassword: string): Observable<string> {
    const url = `https://${environment.authSecrets.cloudFunctionUrl}/api/forced-password-reset`;
    return this.http.post<{ token: string }>(url, { session_token: sessionToken, state, new_password: newPassword }).pipe(
      map(response => response.token),
      catchError((error: HttpErrorResponse) => throwError(() => new Error(error.error?.message ?? FORCED_RESET_FALLBACK_MESSAGE))),
    );
  }

  /** Where Auth0 resumes the interrupted login once the password is set. */
  buildContinueUrl(state: string, token: string): string {
    const params = new URLSearchParams({ state, session_token: token });
    return `https://${environment.authSecrets.domain}/continue?${params.toString()}`;
  }
}
